module.exports = __webpack_public_path__ + "static/media/A2.e7d76c98.jpg";